import {Link} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import {cn} from '@/lib/utils'

/** `compact` drops the secondary link below `sm`: beside a hamburger it does not fit a 360px phone. */
export function SiteHeaderActions({tone, compact}: {tone: 'light' | 'ink'; compact?: boolean}) {
  const {t} = useTranslation()
  return (
    <nav className="flex items-center gap-1.5 sm:gap-5">
      <Link
        to="/login"
        className={cn(
          'inline-flex min-h-11 items-center whitespace-nowrap rounded-lg px-2 text-sm font-medium sm:px-3',
          compact && 'hidden sm:inline-flex',
          tone === 'ink' ? 'text-ink-deep-foreground hover:bg-white/10' : 'text-foreground hover:underline'
        )}
        data-testid="site-header-login">
        {t('landing.nav.login')}
      </Link>
      <Link
        to="/registro/empresa"
        className="inline-flex min-h-11 items-center whitespace-nowrap rounded-lg bg-primary px-3 py-2 text-sm font-semibold text-primary-foreground shadow-button transition-colors hover:bg-primary-hover sm:px-4"
        data-testid="site-header-registro">
        {t('landing.nav.cta')}
      </Link>
    </nav>
  )
}
